import type { FC, ReactNode } from 'react';

import Navbar from 'components/_Navbar';

import { Container, Root } from './index.styled';

interface MainLayoutProps {
  children?: ReactNode;
}

const MainLayout: FC<MainLayoutProps> = ({ children }) => (
  <Root>
    <Navbar />
    <Container>
      {children}
    </Container>
  </Root>
);

export default MainLayout;
